
import { Component, Vue, Prop } from "vue-property-decorator";
import { accountApi } from "../services/api/account/account";
import { UpdatePinCommand } from "../services/api/models/UpdatePinCommand.model";
import TransitionMessage from "./TransitionMessage.vue";

@Component({ components: { TransitionMessage } })
export default class DigitalPin extends Vue {
  @Prop() readonly profile: any;

  private errorMessageShow = false;
  private errorMessage = "";
  private hasPin = false;
  private showPin = false;
  private pin = "";
  private confirmPin = "";
  private isSavingPin = false;
  $t: any;

  async mounted() {
    await this.load();
  }

  async load() {
    let profile = this.profile;
    this.hasPin = profile.hasPin;
  }

  async savePin() {
    this.isSavingPin = true;
    this.errorMessageShow = false;
    this.errorMessage = "";

    if (this.pin != this.confirmPin) {
      this.returnMessage("Los <strong>PIN</strong> ingresados no coinciden.");
    } else if (this.pin.length < 4) {
      this.returnMessage("El <strong>PIN</strong> debe ser de 4 dígitos.");
    } else {
      try {
        const data = new UpdatePinCommand(this.pin, this.confirmPin);
        await accountApi.updatePin(data);
        this.hasPin = true;
      } catch (error) {
        if (error?.response?.data) {
          this.errorMessageShow = true;
          this.errorMessage = this.$t(`errors.${error.response.data}`);
        }
      } finally {
        this.isSavingPin = false;
      }
    }
  }

  returnMessage(text: string) {
    this.isSavingPin = false;
    this.errorMessageShow = true;
    this.errorMessage = text;
  }

  onlyNumber(e: any) {
    let keyCode = e.keyCode ? e.keyCode : e.which;
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      e.preventDefault();
    }
  }
}
